
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { inspectionProduction } from "@/api/api-basic";
// import regular from "@/common/regular";
import i18n from "@/config/i18n";
@Component({
  components: {}
})
export default class ProductionOrderQualityCheck extends Vue {
  private formInline: objAny = {
    verifier: "",
    checkContent: "",
    projectNamePkId: ""
  };
  private formObj: objAny = {};
  private ruleInline: objAny = {
    verifier: [
      {
        required: true,
        message: i18n.t("productionOrder.verifierpPl"),
        trigger: "blur"
      }
    ],
    checkContent: [
      {
        required: true,
        message: i18n.t("productionOrder.checkContentPl"),
        trigger: "blur"
      }
    ]
  };
  private itemData: objAny = {};
  private modalShow = false;
  private loading = false;
  public open(item: objAny) {
    this.modalShow = true;
    this.itemData = item;
    this.formInline.projectNamePkId = item.projectNamePkId;
  }
  public handleSubmit() {
    this.formObj.validate((valid: boolean) => {
      if (valid) {
        this.submitData();
      }
    });
  }
  async submitData(): Promise<void> {
    this.loading = true;
    const ret = await inspectionProduction(this.formInline);
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("operationSucess"));
      this.$emit("success");
      this.modalShow = false;
    }
    this.loading = false;
  }
  public handleReset() {
    this.formObj.resetFields();
  }

  mounted() {
    this.$nextTick(() => {
      this.formObj = this.$refs["formValidate"];
    });
  }
}
